import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVDropdown } from "../../shared/JVDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { JVInput } from "../../shared/JVInput";
import { ILogin } from "../../models/Login";
import { Tooltip } from "primereact/tooltip";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    po: IPurchaseOrder,
    hideDialog: () => void,
    toast: any,
}

interface IEscalationList {
    id?: number,
    pO_ID?: number,
    vendor_Type?: number,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    added_By?: string,
    added_By_ID?: number,
    company?: string,
    branch?: string,
    escalation_Subject?: string,
    escalation_Comment?: string,
    escalation_Status?: string,
    escalation_Status_Comment?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

interface IHistory {
    id?: number,
    escalation_ID?: number,
    prev_Escalation_Status?: string,
    escalation_Status?: string,
    prev_Escalation_Status_Comment?: string,
    escalation_Status_Comment?: string,
    updated_By?: string,
    company?: string,
    branch?: string,
    updated_On?: Date,
}

interface IForm {
    escalation?: string,
    escalationFor?: number,
    escalation_Subject?: string,
    escalation_Status?: string,
    escalation_Status_Comment?: string,
}

const schema = yup.object({
    escalationFor: yup.number().required("Escalation For is required."),
    escalation_Subject: yup.string().required("Escalation Subject is required."),
    escalation_Status: yup.string().nullable(),
    escalation_Status_Comment: yup.string().nullable(),
});

export const Escalation = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IEscalationList[], loading: boolean });
    const [historyTableData, setHistoryTableData] = useState({ tableData: [], loading: false } as { tableData: IHistory[], loading: boolean });
    const [table, setTable] = useState({ tableData: [], loading: false } as { tableData: IPurchaseOrder[], loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [valuetextarea, setValuetextarea] = useState<string>('');
    //const [subjecttextarea, setSubjecttextarea] = useState<string>('');
    const [errortextarea, setErrortextarea] = useState<boolean>(false);
    const [escalationFor, setEscalationFor] = useState<number>(0);
    const [editeIndex, setEditeIndex] = useState<number | null>(null);
    const [historyTable, setHistoryTable] = useState({ singleData: {}, open: false } as { singleData: IEscalationList, open: boolean });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const { control, handleSubmit, formState: { errors }, watch, reset } = useForm<IForm>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    async function saveToDB(body: IForm) {
        setLoading(true);

        const newBody: any = {
            PO_ID: props.po.pO_ID,
            Escalation_Subject: body.escalation_Subject,
            Escalation_Comment: body.escalation,
            Escalation_Status: body.escalation_Status,
            Escalation_Status_Comment: body.escalation_Status_Comment
        };

        const response = await Fetch("vwPODetails/addVendorEscalation", "POST", newBody, `type=${body.escalationFor}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Added Successfully." });
            setLoading(false);
            setValuetextarea('');
            setErrortextarea(false);
            setEscalationFor(0);
            setEditeIndex(null);
            reset({ escalation: "", escalationFor: 0, escalation_Subject: "" });
            loadTableData();
        } else setLoading(false);
    }

    async function saveToDBUpdate(body: IForm) {
        setLoading(true);

        const newBody: any = {
            ID: tableData.tableData.filter(f => f.id === editeIndex)[0].id,
            PO_ID: props.po.pO_ID,
            Escalation_Subject: body.escalation_Subject,
            Escalation_Comment: body.escalation,
            Escalation_Status: body.escalation_Status,
            Escalation_Status_Comment: body.escalation_Status_Comment
        };

        const response = await Fetch("vwPODetails/updateVendorEscalation", "PUT", newBody, `type=${body.escalationFor}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Updated Successfully." });
            setLoading(false);
            setValuetextarea('');
            setErrortextarea(false);
            setEscalationFor(0);
            setEditeIndex(null);
            reset({ escalation: "", escalationFor: 0, escalation_Subject: "" });
            loadTableData();
        } else setLoading(false);
    }

    function onSubmit(data: IForm) {
        if (valuetextarea?.trim() === "") {
            setErrortextarea(true);
        } if (editeIndex !== null && data.escalation_Status === "Unresolved" && (data.escalation_Status_Comment === null || data.escalation_Status_Comment === undefined || data.escalation_Status_Comment?.trim() === "")) {
            props.toast.current.show({ severity: 'error', content: "Please Give Comment On Unresolved Status." });
        } else {
            data.escalation = valuetextarea;
            if (editeIndex !== null) {
                saveToDBUpdate(data);
            } else saveToDB(data);
        }
    }

    function onClear() {
        setLoading(false);
        setValuetextarea('');
        setErrortextarea(false);
        setEscalationFor(0);
        setEditeIndex(null);
        reset({ escalation: "", escalationFor: 0, escalation_Subject: "" });
    }

    function onHide() {
        setLoading(false);
        setValuetextarea('');
        setErrortextarea(false);
        setEscalationFor(0);
        setEditeIndex(null);
        reset({ escalation: "", escalationFor: 0, escalation_Subject: "" });
        props.hideDialog();
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/getVendorEscalation", "GET", null, `poID=${props.po.pO_ID}&companyID=0`, props.toast);
        if (response) {
            const data: IEscalationList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableDataHistory = async (id: number) => {
        setHistoryTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/getVendorEscalationHistory", "GET", null, `historyID=${id}`, props.toast);
        if (response) {
            const data: IHistory[] = await response.json();
            setHistoryTableData({ tableData: data, loading: false });
        } else setHistoryTableData({ tableData: tableData.tableData, loading: false });
    }

    const pDate = (rowData: IEscalationList) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const uDate = (rowData: IEscalationList) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const openEdit = (body: IEscalationList) => {
        reset({ escalationFor: body.vendor_Type, escalation_Subject: body.escalation_Subject || "", escalation_Status: body.escalation_Status || "" });
        setEditeIndex(body.id || 0);
        setEscalationFor(body.vendor_Type || 0);
        setValuetextarea(body.escalation_Comment || "");
    }

    const actionBodyTemplate = (rowData: IEscalationList) => {
        if ((_roles.includes(1) || _roles.includes(20))) {
            return (
                <div className="actions">
                    <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                </div>
            );
        } else if (_roles.includes(4) && rowData.vendor_Type === 2 && rowData.added_By_ID == loginObj.id) {
            return (
                <div className="actions">
                    <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                </div>
            );
        } else if (_roles.includes(5) && rowData.vendor_Type === 1 && rowData.added_By_ID == loginObj.id) {
            return (
                <div className="actions">
                    <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                </div>
            );
        } else {
            return (
                <div className="actions">
                </div>
            );
        }

    };

    const escalation_Status = watch("escalation_Status");

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "escalationFor") {
                if (value.escalationFor === 1) {
                    setEscalationFor(value.escalationFor);
                } else if (value.escalationFor === 2) {
                    setEscalationFor(value.escalationFor);
                } else setEscalationFor(0);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, props.open]);

    useEffect(() => {
        if (props.open && props.po && props.po.pO_ID) {
            loadTableData();
            setTable(prev => prev = { tableData: [props.po], loading: false });
        }
    }, [props.open]);

    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Vendor Escalation" className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">

                <JVDropdown disabled={editeIndex !== null}
                    required
                    label="Escalation For"
                    control={control}
                    name="escalationFor"
                    error={errors.escalationFor?.message}
                    options={(_roles.includes(1) || _roles.includes(20)) ? [{ name: "Prime Vendor", value: 1 }, { name: "Sub Vendor", value: 2 }] : ((_roles.includes(4)) ? [{ name: "Sub Vendor", value: 2 }] : ((_roles.includes(5)) ? [{ name: "Prime Vendor", value: 1 }] : []))}
                    optionLabel="name"
                    optionValue="value"
                    placeholder="Select Escalation For"
                    column={3}
                />
                {(escalationFor === 1 || escalationFor === 2) && <div className="field col-12 md:col-8">
                    <DataTable
                        style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                        size="small"
                        stripedRows
                        showGridlines
                        responsiveLayout="scroll"
                        exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                        value={table.tableData}
                        loading={table.loading}
                    >
                        <Column field="vendor_Company_Name" header="Prime Vendor" />
                        <Column header="Sub Vendor" body={(e) => e.pO_Sub_Vendor_Company !== null ? <p>{e.pO_Sub_Vendor_Company}</p> : <p>{e.sub_Vendor_Company}</p>} />
                        <Column field="salesmanager" header="Sales Manager" body={(rowData) => <p style={{ color: rowData.sales_Status ? "red" : "" }}>{rowData.salesmanager}</p>} />
                        <Column field="sales_Company_Branch" header="Sales Comp (Branch)" />
                        <Column field="user_Name" header="Recruiter" body={(rowData) => <p style={{ color: rowData.recruiter_Status ? "red" : "" }}>{rowData.user_Name}</p>} />
                        <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" />
                    </DataTable>
                </div>}


                <JVInput disabled={editeIndex !== null} required column={3} label="Subject" name="escalation_Subject" control={control} error={errors.escalation_Subject?.message} />

                {editeIndex !== null && <JVDropdown
                    required
                    label="Status"
                    control={control}
                    name="escalation_Status"
                    // error={errors.status?.message}
                    options={[
                        // { name: "Created", value: "Created" },
                        { name: "Resolved", value: "Resolved" },
                        { name: "Unresolved", value: "Unresolved" }
                    ]}
                    optionLabel="name"
                    optionValue="value"
                    placeholder="Select Status"
                    column={3}
                />}

                {editeIndex !== null && <JVInput required={escalation_Status === "Unresolved"} column={3} label="Comment" name="escalation_Status_Comment" control={control} error={errors.escalation_Status_Comment?.message} />}

                <div className="field col-12">
                    <label>Escalation Comment<span style={{ color: 'red' }}>*</span></label>
                    <InputTextarea disabled={editeIndex !== null}
                        className=""
                        value={valuetextarea}
                        onChange={(e) => { setValuetextarea(e.target.value); setErrortextarea(false) }}
                        rows={5}
                        cols={82}
                    />
                    {errortextarea && <small className="p-error">Escalation Reason is Required</small>}
                </div>

                <div className="field col-12 flex gap-3">
                    <Button loading={loading} label="ADD Escalation" type="submit" />
                    <Button className="p-button-outlined" onClick={() => onClear()} label="CLEAR" type="button" />
                </div>
            </form>

            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="vendor_Type" header="Vendor Type" body={(rowData: IEscalationList) => <p>{rowData.vendor_Type === 1 ? "Prime Vendor" : "Sub Vendor"}</p>} />
                <Column field="vendor_Company_Name" header="Vendor Company" />
                <Column field="added_By" header="Added By" />
                <Column field="company" header="Company" />
                <Column field="branch" header="Branch" />
                <Column field="escalation_Subject" header="Escalation Subject" body={(rowData: any) => <div className="flex"><div className={"knob5" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.escalation_Subject}<Tooltip target={".knob5" + rowData.id} position="top" content={`${rowData.escalation_Subject?.trim()}`} /></div><span style={{ color: "#2196F3" }}>{rowData.escalation_Subject?.trim().length > 5 ? "..." : ""}</span></div>} />
                <Column field="escalation_Comment" header="Escalation Comment" body={(rowData: any) => <div className="flex"><div className={"knob6" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{rowData.escalation_Comment}<Tooltip target={".knob6" + rowData.id} position="top" content={`${rowData.escalation_Comment?.trim()}`} /></div><span style={{ color: "#2196F3" }}>{rowData.escalation_Comment?.trim().length > 5 ? "..." : ""}</span></div>} />
                <Column field="escalation_Status" header="Status" />
                {/* <Column field="added_On" header="Added On" body={pDate} /> */}
                <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, 'dd/MM/yyyy', DateFormat)} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="updated_By" header="Updated On" body={uDate} /> */}
                <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat)} />
                <Column field="" header="Action" body={actionBodyTemplate} />
                <Column header="History" body={(rowData: IEscalationList) => <i className="cursor-pointer text-primary pi pi-clock" onClick={() => {
                    loadTableDataHistory(rowData.id || 0);
                    setHistoryTable({ singleData: rowData, open: true });
                }}></i>} />
            </DataTable>
            <Dialog visible={historyTable.open} style={{ width: '80vw' }} header="History of Status" modal className="p-fluid" onHide={() => setHistoryTable({ singleData: {}, open: false })} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" value={historyTableData.tableData} loading={historyTableData.loading} showGridlines stripedRows responsiveLayout="scroll"
                >
                    <Column field="updated_By" header="Updated By" />
                    <Column field="company" header="Company" />
                    <Column field="branch" header="Branch" />
                    <Column field="prev_Escalation_Status" header="Prev Escalation Status" />
                    <Column field="escalation_Status" header="Current Escalation Status" />
                    <Column field="prev_Escalation_Status_Comment" header="Prev Escalation Status Comment" />
                    <Column field="escalation_Status_Comment" header="Current Escalation Status Comment" />
                    {/* <Column field="updated_On" header="Updated On" body={uDate} /> */}
                    <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat)} />
                </DataTable>
            </Dialog>
        </Dialog>
    );
}